import React, { useState } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import MonitorDelays from "./DashboardWidgets/MonitorDelays";
import BottleneckTasks from "./DashboardWidgets/BottleneckTasks";
import EmployeeLoad from "./DashboardWidgets/EmployeeLoad";

function KpiCard({ label, value }) {
    return (
        <Paper sx={{ px: 2, py: 2, height: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
            <Typography variant="caption" color="text.secondary" sx={{ textTransform: "uppercase", letterSpacing: 0.5 }}>
                {label}
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
                {value === null ? "—" : value}
            </Typography>
        </Paper>
    );
}

export default function WorkflowDashboard(props) {
    const [delaysCount, setDelaysCount] = useState(null);
    const [bottlenecksCount, setBottlenecksCount] = useState(null);
    const [employeeLoadCount, setEmployeeLoadCount] = useState(null);

    return (
        <Box sx={{ pt: 1, pb: 1, height: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Grid container spacing={1}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <KpiCard label="Workflows With Delays" value={delaysCount} />
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <KpiCard label="Bottleneck Tasks" value={bottlenecksCount} />
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <KpiCard label="Employees Blocked" value={employeeLoadCount} />
                </Grid>
            </Grid>
            <Grid container spacing={1} sx={{ flex: 1, minHeight: 0 }}>
                <Grid size={{ xs: 12, md: 9 }} sx={{ height: { xs: 'auto', md: '100%' }, minHeight: 0 }}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Box sx={{ flex: 1, minHeight: 0 }}>
                            <MonitorDelays {...props} onRowCountChange={setDelaysCount} />
                        </Box>
                        <Box sx={{ flex: 1, minHeight: 0 }}>
                            <BottleneckTasks {...props} onRowCountChange={setBottlenecksCount} />
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 3 }} sx={{ height: { xs: 'auto', md: '100%' }, minHeight: 0 }}>
                    <EmployeeLoad {...props} onRowCountChange={setEmployeeLoadCount} />
                </Grid>
            </Grid>
        </Box>
    );
};
